import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { PAGE_HEADER_VERSION_CONFIG } from '../../../../../layout/page/header/page-header.config';

export const PRODUCT_VIEW_EXTERNAL_CONFIG: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: 'product-page-external',
    onDemandOnly: true,
    block: {
        url: 'product-page-external'
    },
    name: 'Product page external',
    description: 'Product page external block',
    fields: [
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom components',
            itemName: 'component',
            default: []
        },
        ...PAGE_HEADER_VERSION_CONFIG.filter(field => field.key !== 'headerHideUp'),
        <NICmsContentField.IField>{
            key: 'other',
            type: NICmsContentField.EFieldType.label,
            title: 'Other'
        },
        <NICmsContentField.IField>{
            key: 'allow_financing_tray',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Allow Financing Tray',
            default: false
        }
    ]
};
